// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1SqBF","colMaxWidth":"Table_colMaxWidth__27yVJ"};